import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Linkedin, Youtube } from "lucide-react";

export function Footer() {
  return (
    <footer className="border-t border-border/40 bg-background/80 backdrop-blur-sm mt-16 md:mt-20">
      <div className="container-responsive py-10 md:py-12">
        <div className="space-y-6 md:space-y-8">
          {/* Trust Banner */}
          <div className="text-center max-w-3xl mx-auto">
            <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
              <strong className="text-foreground">Trusted by builders worldwide.</strong>{" "}
              DayOne uses real data to separate signal from noise.
            </p>
          </div>

          {/* Data Sources */}
          <div className="text-center">
            <p className="text-xs text-muted-foreground mb-3 md:mb-4">Powered by Trusted Data</p>
            <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-xs text-muted-foreground/60">
              <span>Google Trends</span>
              <span>·</span>
              <span>Product Hunt</span>
              <span>·</span>
              <span>NewsAPI</span>
              <span>·</span>
              <span>YouTube</span>
              <span>·</span>
              <span>Reddit</span>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 pt-6 border-t border-border/40">
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-2 gap-y-1 text-xs text-muted-foreground">
              <span>© 2026 DayOne</span>
              <span className="text-border">|</span>
              <span>Built for Entrepreneurs</span>
              <span className="text-border">|</span>
              <Link to="/privacy" className="hover:text-primary transition-colors">Privacy Policy</Link>
              <span className="text-border">|</span>
              <Link to="/terms" className="hover:text-primary transition-colors">Terms of Service</Link>
              <span className="text-border">|</span>
              <span>support@usedayone.net</span>
            </div>
            <div className="flex items-center gap-4">
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors hover-scale">
                <Twitter className="h-4 w-4" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors hover-scale">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-primary transition-colors hover-scale">
                <Youtube className="h-4 w-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
